module.exports = __webpack_public_path__ + "static/media/repay64.d2a14c9a.png";